<template>
    <div class="bind-phone-table">
        <div class="bind-phone-table-top">
            当前{{ canUseTelx.length ? "可" : "无" }}拨打虚拟号码
            <span class="bind-phone-table-num">{{ canUseTelx[0] && canUseTelx[0].telx }}</span></div>
        <veui-table
            v-if="recordData.length"
            ui="m"
            class="bind-phone-table-content"
            key-field="id"
            align="center"
            scroll="222"
            :data="recordData"
        >
            <veui-table-column
                field="bind_time"
                title="绑定时间"
                width="172"
            />
            <veui-table-column
                field="tela"
                title="主呼叫号码"
                width="127"
            />
            <veui-table-column
                field="bind_status"
                title="状态"
                width="75"
            >
                <template slot-scope="{bind_status}">
                    <span>{{ +bind_status === 1 ? '有效' : '无效' }}</span>
                </template>
            </veui-table-column>
        </veui-table>
        <div v-else class="bind-phone-table-empty">
            <img src="../image/icon-empty.png">
        </div>
    </div>
</template>

<script>
/**
 * @file bindPhoneTable.vue
 * @desc 线索详情绑定记录表格
 * @author sunxiaofeng01
 */
import {Table, Column} from 'veui';

export default {
    name: 'bindPhoneTable',
    data() {
        return {};
    },
    computed: {
        canUseTelx() {
            return this.recordData.filter(item => +item.bind_status === 1) || [];
        }
    },
    props: {
        recordData: {
            'type': Array,
            'default': () => []
        }
    },
    components: {
        'veui-table': Table,
        'veui-table-column': Column
    }
};
</script>

<style scoped lang="stylus">
.bind-phone-table
    margin-bottom 24px
    .bind-phone-table-top
        margin-bottom 24px
        height 18px
        line-height 18px
    .bind-phone-table-num
        font-family PingFangSC-Medium
        font-size 18px
        color #282C33
    .bind-phone-table-content
        border 1px solid #d3d9e6
        /deep/.veui-table-main, /deep/.veui-table-fixed-header
            [role="columnheader"]
                font-family PingFangSC-Medium
                background-color rgb(237,243,255)
                border-right 1px solid #d3d9e6
            [role="cell"]
                border-right 1px solid #d3d9e6
            .veui-table-cell
                justify-content center
            .veui-table-cell-last
                border-right none
         /deep/.veui-table-fixed-header
            .veui-table-gutter
                border-right none
    .bind-phone-table-empty {
        min-height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
